import { client } from './client'
import type {
  CreateWorkflowScheduleRequest,
  PagedResult,
  PaginationParams,
  UpdateWorkflowScheduleRequest,
  WorkflowSchedule,
  WorkflowScheduleCreated,
  WorkflowScheduleListFilters,
  WorkflowScheduleOccurrence,
  WorkflowScheduleOccurrenceFilters,
  WorkflowSchedulePreviewResponse,
  WorkflowScheduleRecurrenceRequest,
  WorkflowScheduleSummary,
} from '@/types'

const base = (projectId: string) => `/projects/${projectId}/workflow-schedules`

export const workflowSchedulesApi = {
  getAll: (projectId: string, filters?: WorkflowScheduleListFilters, pagination?: PaginationParams) =>
    client.get<PagedResult<WorkflowScheduleSummary>>(base(projectId), {
      params: { ...filters, ...pagination },
    }).then(r => r.data),

  getById: (projectId: string, scheduleId: string) =>
    client.get<WorkflowSchedule>(`${base(projectId)}/${scheduleId}`).then(r => r.data),

  create: (projectId: string, data: CreateWorkflowScheduleRequest) =>
    client.post<WorkflowScheduleCreated>(base(projectId), data).then(r => r.data),

  update: (projectId: string, scheduleId: string, data: UpdateWorkflowScheduleRequest) =>
    client.put<void>(`${base(projectId)}/${scheduleId}`, data).then(r => r.data),

  delete: (projectId: string, scheduleId: string) =>
    client.delete<void>(`${base(projectId)}/${scheduleId}`).then(r => r.data),

  pause: (projectId: string, scheduleId: string) =>
    client.post<void>(`${base(projectId)}/${scheduleId}/pause`).then(r => r.data),

  resume: (projectId: string, scheduleId: string) =>
    client.post<void>(`${base(projectId)}/${scheduleId}/resume`).then(r => r.data),

  getOccurrences: (
    projectId: string,
    scheduleId: string,
    filters?: WorkflowScheduleOccurrenceFilters,
    pagination?: PaginationParams,
  ) =>
    client.get<PagedResult<WorkflowScheduleOccurrence>>(`${base(projectId)}/${scheduleId}/occurrences`, {
      params: { ...filters, ...pagination },
    }).then(r => r.data),

  preview: (projectId: string, data: WorkflowScheduleRecurrenceRequest) =>
    client.post<WorkflowSchedulePreviewResponse>(`${base(projectId)}/preview`, data).then(r => r.data),
}
